/**
 * Centralized business / brand configuration for R&R House Renovation LLC.
 * All hard-coded brand details should pull from here.
 */

export const siteConfig = {
  name: "R&R House Renovation LLC",
  shortName: "R&R House Renovation",
  legalName: "R&R House Renovation LLC",
  owner: "Eduard Antonio Pérez Rivera",
  // EIN is intentionally NOT stored here — it was supplied for A2P/10DLC
  // messaging registration, which is configured in the messaging provider,
  // not on the public site.
  tagline: "Insurance Claims, Restoration & Full Home Renovation in DFW",
  description:
    "Licensed home renovation and restoration contractor based in Aubrey, TX serving Denton, Frisco, Dallas, Fort Worth, Arlington and the greater DFW metroplex. Insurance claim specialists for water, fire, and storm damage — plus roofing, concrete, carpentry, painting, flooring, and full kitchen and bathroom remodels.",

  domain: "rrhouserenovationllc.com",
  url: "https://rrhouserenovationllc.com",

  phone: "(936) 371-1087",
  phoneHref: "tel:+19363711087",

  email: "houserenovation1116@gmail.com",
  emailHref: "mailto:houserenovation1116@gmail.com",

  address: {
    street: "Irick Ct",
    city: "Aubrey",
    state: "TX",
    stateFull: "Texas",
    postalCode: "76227",
    country: "US",
    region: "Denton County",
    serviceRadius: "50 miles",
    full: "Irick Ct, Aubrey, TX 76227",
  },

  hours: {
    summary: "Mon – Sat · 7 AM – 6 PM",
    days: "Monday – Saturday",
    time: "7:00 AM – 6:00 PM",
    closed: "Sunday",
  },

  logo: "/rr-house-renovation-logo.png",
  ogImage: "/rr-house-renovation-og.png",
  favicon: "/favicon-64.png",

  social: {
    instagram: "https://www.instagram.com/house_renovationllc",
    facebook: "https://www.facebook.com/profile.php?id=61583506843616",
    tiktok: null,
    yelp: null,
  },

  discount: {
    label: "10% Off Your Next Referral Project",
    short: "10% Referral Discount",
    description:
      "Refer a friend and take 10% off your next project with us. Your referral saves 5% on their first project too — our thank-you for trusting us with your home.",
    referrerPercent: "10%",
    refereePercent: "5%",
  },

  /** LeadConnector chat / form widgets plus GMB review embed for R&R House Renovation. */
  widgets: {
    chatWidgetId: "6a753f59743181907f965007",
    chatLoaderSrc: "https://widgets.leadconnectorhq.com/loader.js",
    chatResourcesUrl: "https://widgets.leadconnectorhq.com/chat-widget/loader.js",

    gmbReviewIframeSrc: "https://embed.gmbwidget.com/review-widget/w/rw_4d6ca48c4c09e959f605ef68",

    formIframeSrc: "https://link.systemic-digital.net/widget/form/g1LPrRdDla3J4TQXPLM3",
    formScriptSrc: "https://link.systemic-digital.net/js/form_embed.js",
    formId: "g1LPrRdDla3J4TQXPLM3",
    formName: "Website Form",
    formHeight: "729",
  },

  serviceAreas: [
    "Aubrey, TX",
    "Denton, TX",
    "Frisco, TX",
    "Dallas, TX",
    "Grand Prairie, TX",
    "Arlington, TX",
    "Fort Worth, TX",
    "Lewisville, TX",
    "Garland, TX",
    "Grapevine, TX",
  ],
} as const;

export type SiteConfig = typeof siteConfig;
